module.exports = __webpack_public_path__ + "57d2ab58f6ef130a5f087c4eb5ca0b30.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1154
// module chunks = 0